import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Container, SubContainer } from '../../components/Container';
import { consentId } from '../../services/api';
import { metricas } from '../../services/metricas.service';
import { DadosMetricasPCM } from '../../interfaces/metricas';
import { removeUnsafeCharsFromString } from '../../common/Helpers';
import helper from './../../common/Helpers';


const Home = (): JSX.Element => {
  const history = useNavigate();
  const authContext = useContext(AuthContext);
  const [disableLogin, setDisableLogin] = useState(true);

  const location = useLocation()

  const login = () => {
    if (/Android/i.test(navigator.userAgent)) {
      const cleanSearch = removeUnsafeCharsFromString(location.search)
      window.location.href = `unicredMobile://openfinance${cleanSearch}`;    
    }
    
    setTimeout(async () => {
      await enviarEventoPreLogin();
      authContext.login();
    }, 100);
  };

  const enviarEventoPreLogin = async () => {
    const { version, os } = helper.getOS(navigator.userAgent);

    const payload: DadosMetricasPCM = {
      consentId: consentId,
      osVersion: version,
      os,
      type: "AWAITING_USER_AUTH",
      step: "REDIRECT_TARGET",
    }

    await metricas.enviarEventoPreLogin(payload)
      .catch(() => { });
  }

  const enviarEventoPosLogin = async () => {
    const { version, os } = helper.getOS(navigator.userAgent);

    const payload: Omit<DadosMetricasPCM, "uriAuthorizationEndpoint" | "type" | "completeURL"> = {
      consentId: consentId,
      osVersion: version,
      os,
      step: "AUTHENTICATED"
    }

    await metricas.enviarEventoPosLogin(payload)
      .catch(() => { });
  }
          
  useEffect(() => {
    const validarAutenticacao = async () => {
      if (authContext.hasStarted) {
        if (authContext.isAuthenticated) {
          setDisableLogin(true);
          await enviarEventoPosLogin();  
          history('/carregando');        
        } else {
          setDisableLogin(false);
        }
      }
    };

    validarAutenticacao();
  }, [authContext]);

  return (
    <Container>
      <SubContainer>{!disableLogin && (login(), null)}</SubContainer>
    </Container>
  );
};

export default Home;